import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Faq } from 'bookraw/shared/models/faq.model';

@Injectable()
export class FaqsService extends ListService<Faq> {

  url: string = '/api/admin/faqs';
}
